import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import moment from "moment";
import FilterSelectedColumnLabel from "../Presentational/ReportBuilder/FilterSelectedColumnLabel";
import { getIdProvider } from "../../../util/IDProvider";
import DateUtils from "../../../util/dateUtils";
import LinkToPerson from "../Presentational/Person/LinkToPerson/LinkToPerson";
const ReportDataTable = (props) => {
    const rowIdProvider = getIdProvider();
    const headerCellIdProvider = getIdProvider();
    // @ts-expect-error - TS7006 - Parameter 'sc' implicitly has an 'any' type.
    function renderReportHeader(sc) {
        return (_jsxs("th", { style: { cursor: "pointer", whiteSpace: "nowrap" }, children: [_jsx("button", { className: "btn btn-link p-0", onClick: () => {
                        props.onSort(sc);
                    }, children: _jsx(FilterSelectedColumnLabel, { filterSelectedColumn: sc }) }), " ", props.orderBy.orderByColumnId === sc.id &&
                    (props.orderBy.sortDirection === "Ascending" ? (_jsx("span", { className: "fas fa-sort-up", title: "Sorted ascending" })) : (_jsx("span", { className: "fas fa-sort-down", title: "Sorted descending" })))] }, headerCellIdProvider.getAndIncrement()));
    }
    function renderDataCell(index, sc, row) {
        if (sc.filterSourceColumn) {
            const { sqlColumnName } = sc.filterSourceColumn;
            let content;
            let columnName;
            if (sc.filterSourceRelationship) {
                // If the column was selected through a releationship, the filter source relationship ID is
                // used as part of the column alias so it's uniquely identified through that relationship
                // (otherwise) there would be name conflicts between different relationships of the same source,
                // or even from the base filter source in some cases.
                columnName = `${sc.filterSourceRelationship.id}_${sqlColumnName}`;
                // content = row[`${sc.filterSourceRelationship.id}_${sqlColumnName}`];
            }
            else {
                columnName = sqlColumnName;
            }
            if (sc.format && sc.format !== "None") {
                columnName += `_${sc.format.toLowerCase()}`;
            }
            content = row[columnName];
            if (sc.aggregateFunction === null) {
                if (content === true || content === false) {
                    content = content ? "Yes" : "No";
                }
                if (sc.filterSourceColumn.displayFormat) {
                    // eslint-disable-next-line no-prototype-builtins
                    if (!Object.hasOwnProperty.call(row, sqlColumnName)) {
                        content = `Display error: could not find ${sqlColumnName}`;
                    }
                    // Replace {column_name} with the value from the data.
                    const regex = /\{([^}]+)\}/g;
                    if (sc.filterSourceRelationship) {
                        content = sc.filterSourceColumn.displayFormat.replace(regex, 
                        // @ts-expect-error - TS2531 - Object is possibly 'null'.
                        (match, p1) => row[`${sc.filterSourceRelationship.id}_${p1}`]);
                    }
                    else {
                        content = sc.filterSourceColumn.displayFormat.replace(regex, (match, p1) => row[p1]);
                    }
                    return (
                    // eslint-disable-next-line react/no-danger
                    _jsx("td", { dangerouslySetInnerHTML: { __html: content } }, index));
                }
                if (content &&
                    // If the filterColumnType is "DATE" or "DATETIME"
                    ["DATE", "DATETIME"].includes(sc.filterSourceColumn.filterColumnType)) {
                    // Detect formats like "Month", Day of Week, and replace them with human-readable names.
                    switch (sc.format) {
                        case "Month":
                            content = DateUtils.getMonthName(content);
                            break;
                        case "DayOfWeek":
                            content = DateUtils.getDayOfWeekName(content);
                            break;
                        case "YearMonth":
                            content = DateUtils.getYearMonthDisplay(content.toString());
                            break;
                        case "YearQuarter":
                            content = DateUtils.getYearQuarterDisplay(content.toString());
                            break;
                        case "Date":
                            content = moment(content).format("M/D/YY");
                            break;
                        case "None":
                        case null:
                            // If it's a date time, show the time, otherwise just show the date.
                            if (sc.filterSourceColumn.filterColumnType === "DATETIME") {
                                content = moment(content).format("M/D/YY h:mm A");
                            }
                            else {
                                content = moment(content).format("M/D/YY");
                            }
                            break;
                        default:
                        // Do nothing. No transformation needed.
                    }
                }
                if (content &&
                    // If the filterColumnType is link
                    ["LINK"].includes(sc.filterSourceColumn.filterColumnType)) {
                    const obj = JSON.parse(content);
                    return (_jsx("td", { children: _jsx(LinkToPerson, { affiliationId: obj.affiliation_id, target: "_blank", children: obj.institution_person_id }) }, index));
                }
            }
            return _jsx("td", { children: content }, index);
        }
        return _jsx("td", {}, index);
    }
    function renderReportData() {
        if (!props.reportData) {
            return "";
        }
        return (_jsxs("table", { className: `table ${props.bordered === false ? "" : "table-bordered"} table-striped table-hover ${props.tableClassName || ""}`, children: [_jsx("thead", { children: _jsx("tr", { children: props.filter &&
                            props.filter.selectedColumns &&
                            props.filter.selectedColumns.map((sc) => renderReportHeader(sc)) }) }), _jsx("tbody", { children: props.reportData.map((row) => (_jsx("tr", { children: props.filter &&
                            props.filter.selectedColumns &&
                            props.filter.selectedColumns.map((sc, index) => renderDataCell(index, sc, row)) }, rowIdProvider.getAndIncrement()))) })] }));
    }
    function renderPaging() {
        if (props.reportData) {
            return (_jsxs("div", { className: `btn-group ${props.pagingContainerClassName ? props.pagingContainerClassName : ""}`, children: [_jsxs("button", { type: "button", className: "btn btn-outline-secondary", disabled: props.isRunningFilter || props.pageIndex === 0, onClick: () => props.onPrevPageClick(), children: [_jsx("span", { className: "fa fa-chevron-left", "aria-hidden": "true" }), " Prev"] }), _jsxs("button", { type: "button", className: "btn btn-outline-secondary", disabled: props.isRunningFilter || !props.hasNextPage, onClick: () => props.onNextPageClick(), children: ["Next ", _jsx("span", { className: "fa fa-chevron-right", "aria-hidden": "true" })] })] }));
        }
        return "";
    }
    return (_jsxs(_Fragment, { children: [renderReportData(), renderPaging()] }));
};
export default ReportDataTable;
